
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ProductHero from './components/ProductHero';
import TechnologyStack from './components/TechnologyStack';
import DataProcessing from './components/DataProcessing';
import SignalGeneration from './components/SignalGeneration';

const ProductPage = () => {
  return (
    <div className="min-h-screen bg-dark text-beige-light font-sans">
      <Navbar />
      <main>
        <ProductHero />
        <TechnologyStack />
        <DataProcessing />
        <SignalGeneration />
      </main>
      <Footer />
    </div>
  );
};

export default ProductPage;
